<template>
    <div class="content">
        <div class="row">
            <div class="col-md-12">
                <a-card>
                    <a-switch v-model="info.status" @change="changeStatus(info.id)" />
                    &nbsp;
                    <span>فعال بودن آگهی</span>

                    <form @submit.prevent="addData($event)">
                        <div class="row">
                            <a-divider orientation="left">اطلاعات کلی </a-divider>

                            <div class="col-md-3 my-1">
                                <div class="form-group ">
                                    <label>عنوان</label>
                                    <input type="text" name="title" v-model="info.title" class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-3 my-1">
                                <div class="form-group ">
                                    <label class="sr-only" for="inline-form-input-name">
                                        دسته بندی</label>
                                    <a-select mode="single" style="width:100%" placeholder="انتخاب دسته بندی "
                                        v-model="info.category_id">
                                        <a-select-option v-for="cat in cats" :key="cat.id"
                                            :value="cat.id">
                                            {{ cat . title }}
                                        </a-select-option>
                                    </a-select>
                                </div>
                            </div>
                            <div class="col-md-3 my-1">
                                <div class="form-group ">
                                    <label class="sr-only" for="inline-form-input-name">
                                        واحد</label>
                                    <a-select mode="single" style="width:100%" placeholder="انتخاب واحد  "
                                        v-model="info.unit_id">
                                        <a-select-option v-for="unit in units" :key="unit.id"
                                            :value="unit.id">
                                            {{ '' + unit . name + ' ( x  ' + unit . count + ')' }}
                                        </a-select-option>
                                    </a-select>
                                </div>
                            </div>
                            <div class="col-md-3 my-1">
                                <div class="form-group ">
                                    <label class="sr-only" for="inline-form-input-name">
                                        منطقه فروش</label>
                                    <a-tree-select v-model="info.area_id" show-search style="width: 100%"
                                        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                                        placeholder="انتخاب استان و شهر و منطقه " allow-clear tree-default-expand-all>
                                        <a-icon slot="suffixIcon" type="smile" />
                                        <a-tree-select-node v-for="state in states" :key="'state' + state.id"
                                            :value="'state' + state.id" :title="state.name">
                                            <a-tree-select-node v-for="city in state.cities" :key="'city' + city.id"
                                                :value="'city' + city.id" :title="city.name">
                                                <a-tree-select-node v-for="area in city.areas" :key="'area' + area.id"
                                                    :value="'area' + area.id" :title="area.name" />

                                            </a-tree-select-node>

                                        </a-tree-select-node>


                                    </a-tree-select>
                                </div>
                            </div>
                            <div class="col-md-3 ">
                                <div class="form-group">
                                    <label style="margin-bottom:10px;">تاریخ انقضا </label>
                                    <date-picker v-model="info.expired_date"></date-picker>

                                </div>
                            </div>
                            <div class="col-md-3 my-1">
                                <div class="form-group ">
                                    <label> موجودی محصول /تعداد</label>
                                    <input v-model="info.stock_count" type="text" class="form-control" />
                                </div>
                            </div>
<div class="col-md-3 my-1">
                                    <label class="sr-only" for="inline-form-input-name">
                                        فروشنده</label>
                                 <input :value="info.presenter ? info.presenter.firstname+' '+info.presenter.lastname : ''" type="text" class="form-control" />

                                </div>
                            <a-divider orientation="left">

                                اطلاعات قیمت (ریال) </a-divider>
                            <div class="col-md-3 my-1">
                                <div class="form-group ">
                                    <label>قیمت اصلی</label>
                                    <a-input-number v-model="info.cost" class="form-control" :default-value="1000"
                                        :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                        :parser="value => value.replace(/\$\s?|(,*)/g, '')" @change="onChange" />
                                </div>
                            </div>
                            <div class="col-md-3 my-1">
                                <div class="form-group ">
                                    <label>قیمت با تخفیف</label>
                                    <a-input-number v-model="info.discounted_cost" class="form-control"
                                        :default-value="1000"
                                        :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                        :parser="value => value.replace(/\$\s?|(,*)/g, '')" @change="onChange" />
                                </div>
                            </div>
                            <div class="col-md-3 my-1">
                                <div class="form-group ">
                                    <label>مقدار نقدی</label>
                                    <a-input-number v-model="info.cash" class="form-control" :default-value="1000"
                                        :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                        :parser="value => value.replace(/\$\s?|(,*)/g, '')" @change="onChange" />
                                </div>
                            </div>
                            <div class="col-md-3 my-1">
                                <div class="form-group ">
                                    <label>مقدار تهاتری</label>
                                    <a-input-number v-model="info.barter" class="form-control" :default-value="1000"
                                        :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                        :parser="value => value.replace(/\$\s?|(,*)/g, '')" @change="onChange" />
                                </div>
                            </div>
                            <a-divider orientation="left" >مشخصات محصول </a-divider>

                            <table class="table table-stripped table-bordered table-hover m-md-1" >
                                <thead>
                                    <tr>
                                        <th scope="col">نام مشخصه</th>
                                        <th scope="col">مقادیر مشخصه</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="value,parent in info.all_properties">
                                        <td scope="col">{{ parent }}</td>
                                        <td scope="col">{{ value }}</td>

                                    </tr>
                                </tbody>

                            </table>
                            <a-divider orientation="left" v-if="info.variables.length">متغیر های محصول </a-divider>


                            <div v-if="info.variables.length">
                                <table class="table table-stripped table-bordered table-hover">
                                    <thead>
                                        <tr>
                                            <th scope="col"># </th>
                                            <th scope="col">تصویر</th>
                                            <th scope="col">نام مشخصه</th>
                                            <th scope="col">مقدار مشخصه</th>
                                            <th scope="col">قیمت اصلی</th>
                                            <th scope="col">قیمت با تخفیف</th>
                                            <th scope="col">مقدار نقدی</th>
                                            <th scope="col">مقدار تهاتری
                                            </th>
                                            <th scope="col"> موجودی
                                            </th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in info.variables">
                                            <td scope="col">{{ item . id }}</td>
                                            <td scope="col">
                                                <b-avatar size="4rem"
                                                :src="item.image ? $root.image_concat(item.image.path) : ''">
                                            </b-avatar>

                                            </td>
                                            <td scope="col">{{ item . type . title }}</td>
                                            <td scope="col">{{ item . value . title }}</td>
                                            <td scope="col">{{ $root . number_format(item . cost) }}</td>
                                            <td scope="col">{{ $root . number_format(item . discounted_cost) }}</td>
                                            <td scope="col">{{ $root . number_format(item . cash) }}</td>
                                            <td scope="col">{{ $root . number_format(item . barter) }}</td>
                                            <td scope="col">{{ item . stock_count }}</td>

                                        </tr>
                                    </tbody>

                                </table>
                            </div>
                            <a-divider orientation="left">عکس و توضیحات</a-divider>
                            <div class=" m-2">
                                <a-upload  list-type="picture" disabled
                                    :default-file-list="fileList" class="upload-list-inline">
                                    <!-- <a-button>
                                        <a-icon type="upload" /> آپلود عکس
                                    </a-button> -->
                                </a-upload>
                            </div>
                            <div class="col-md-12 mt-1">
                                <div class="form-group">
                                    <b-form-textarea name="description" id="textarea" v-model="info.description"
                                        placeholder="توضیحات ..." rows="3" max-rows="6"></b-form-textarea>
                                </div>
                            </div>



                            <a-divider orientation="left"> انتخاب از روی نقشه </a-divider>
                            <ShowMap  :center="[location.lat,location.lng]" :marker="location" />

                        </div>
                        
                    </form>
                </a-card>
            </div>
        </div>
    </div>
</template>

<script>
    import ShowMap from '../../components/Blocks/ShowMap.vue';


    function getBase64(img, callback) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }
    export default {
        components: {
            ShowMap
        },

        data() {
            return {
                number: 1,
                number2: 1,
                fileList: [],
                info: {},
                cats: [],
                users: [],
                units: [],
                states: [],
                value: undefined,
                location: {
                    lat: '',
                    lng: ''
                }

            };
        },
        mounted() {
            this.getCats();
            this.getUnits();
            this.getStates();
            this.getData();
        },
        methods: {
            
            getLocation(value) {
                this.location.lat = value.position.lat
                this.location.lng = value.position.lng
            },

            onChange(image) {
                if (image) {
                    this.image = image
                } else {
                }
            },

            getData() {
                let _this = this;
                axios
                    .get("/products/single/" + this.$route.params.id)
                    .then(function(response) {
                        _this.info = response.data;
                        _this.info.area_id = 'area' + _this.info.area_id;
                        _this.location.lat=_this.info.lat;
                        _this.location.lng=_this.info.lng;
                        for (let i = 0; i <= _this.info.images.length; i++) {
                           let img= {
                                uid: _this.info.images[i].id,
                                name: _this.info.images[i].path,
                                status: 'done',
                                url: _this.$root.image_concat(_this.info.images[i].path),
                                thumbUrl: _this.$root.image_concat(_this.info.images[i].path),
                            }
                            _this.fileList.push(img);
                        }
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },

            async getCats() {
                let _this = this;
                let url = '/categories/all';
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.cats = response.data.data;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },

            async getUnits() {
                let _this = this;
                let url = '/units/all';
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.units = response.data.data;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },

            async getStates() {
                let _this = this;
                let url = '/products/states';
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.states = response.data.data;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
            handleChange(info) {
                if (info.file.status === 'uploading') {
                    this.loading = true;
                    return;
                }
                if (info.file.status === 'done') {
                    // Get this url from response in real world.
                    getBase64(info.file.originFileObj, imageUrl => {
                        this.imageUrl = imageUrl;
                        this.loading = false;
                    });
                }
            },
            beforeUpload(file) {
                const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
                if (!isJpgOrPng) {
                    this.$message.error('You can only upload JPG file!');
                }
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error('Image must smaller than 2MB!');
                }
                return isJpgOrPng && isLt2M;
            },
            async changeStatus(id){
              let _this = this;
                this.$store.state.loading = true;
                let url =
                    `/products/status/${id}`;
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.getData();
                        _this.$toast.success("محصول مورد نظر با موفقیت ویرایش شد.");

                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
        },
    };
</script>
<style scoped>
    /* tile uploaded pictures */
    .upload-list-inline>>>.ant-upload-list-item {
        float: left;
        width: 200px;
        margin-right: 8px;
    }

    .upload-list-inline>>>.ant-upload-animate-enter {
        animation-name: uploadAnimateInlineIn;
    }

    .upload-list-inline>>>.ant-upload-animate-leave {
        animation-name: uploadAnimateInlineOut;
    }

    .avatar-uploader>.ant-upload {
        width: 128px;
        height: 128px;
    }

    .ant-upload-select-picture-card i {
        font-size: 32px;
        color: #999;
    }

    .ant-upload-select-picture-card .ant-upload-text {
        margin-top: 8px;
        color: #666;
    }
</style>
